// extracted by mini-css-extract-plugin
export default {"container":"CoursesAccessCell_container__DYaUl","mainContent":"CoursesAccessCell_mainContent__rmrZn","showOrHideButton":"CoursesAccessCell_showOrHideButton__QTH9b"};